import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useCurrentFirm } from '../hooks/queries/useLawFirms';
import MarketingLayout from './components/Layout/MarketingLayout';
import Pipeline from './components/Pipeline/Pipeline';
import Funnel from './components/Funnel/Funnel';
import Feedback from './components/Feedback/Feedback';
import Search from './components/Search/Search';
import Assistant from './components/Assistant/Assistant';
import TmWatch from './components/TmWatch/TmWatch';
import Reports from './components/Reports/Reports';
import ReportDetail from './components/Reports/ReportDetail';
import VisitorProfile from './components/VisitorProfile/VisitorProfile';
import './MarketingApp.css';

/**
 * Marketing Ops Dashboard
 * Admin-only access — redirects non-admins to /dashboard (no error page, no 403).
 * Same pattern as AttorneyApp but gated on admin role instead of law firm.
 */
function MarketingApp() {
  const { isLoaded, isSignedIn } = useUser();
  const { data: firmData, isLoading: firmLoading } = useCurrentFirm();

  // Must be admin (internal MarkoTM org member with admin role)
  const isAdmin = firmData?.permissions?.isAdmin === true;
  const isInternal = firmData?.firm?.isInternal === true;
  const hasAccess = isAdmin && isInternal;

  if (!isLoaded || firmLoading) {
    return (
      <div className="mkt-loading">
        <div className="mkt-loading-spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  // Non-admin or not signed in → redirect to dashboard (404-like, don't reveal route)
  if (!isSignedIn || !hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <MarketingLayout>
      <Routes>
        <Route index element={<Navigate to="pipeline" replace />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="funnel" element={<Funnel />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="search" element={<Search />} />
        <Route path="assistant" element={<Assistant />} />
        <Route path="tmwatch" element={<TmWatch />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports/:id" element={<ReportDetail />} />
        <Route path="visitor/:id" element={<VisitorProfile />} />
        <Route path="*" element={<Navigate to="pipeline" replace />} />
      </Routes>
    </MarketingLayout>
  );
}

export default MarketingApp;
